import { useMediaQuery } from "@react-hook/media-query";
import { DatePicker, Modal, Spin, message } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import React, { useState } from "react";
import { Col, Container, Form, InputGroup, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import circletick from "../../Assests/Circle_Check.svg";
import contactmobile from "../../Assests/Contact.svg";
import imagefive from "../../../src/Assests/CEO/imagefive.svg";

import greentick from "../../Assests/Greentick.svg";
import popupimage from "../../Assests/Popupimage.svg";
import contactperson from "../../Assests/Web.svg";
// import { useApi } from "../../Services/useApi";
import { CountryData } from "../datas/formdata";
import ContactWrap from "./style";
import { useApi } from "../../Reusable/Useapi";
dayjs.extend(customParseFormat);

export const Contact = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width: 768px)");
  const { request, loading } = useApi();
  const [messageApi, contextHolder] = message.useMessage();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    control,
    clearErrors,
  } = useForm();

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const sanitizeDigits = (event) => {
    event.target.value = event.target.value.replace(/\D/g, "");
  };

  const validateEmail = (value) => {
    const isValidEmail = /^[a-zA-Z0-9.%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
      value
    );
    return isValidEmail;
  };

  const [selectedDate, setSelectedDate] = useState(null);

  const handleClearDate = () => {
    setSelectedDate(null);
  };

  const onSubmit = async (data) => {
    try {
      const payload = {
        first_name: data.fname,
        last_name: data.lname,
        country: data.country,
        phone: data.phoneNumber,
        work_mail: data.emailid,
        company_name: data.companyName,
        role: data.role,
        industry: data.industry,
        number_of_vehicles: Number(data.numberOfVehicles),
        date_available: data.date ? dayjs(data.date).format("YYYY-MM-DD") : "",
        description: data.description,
      };

      const response = await request({
        method: "post",
        url: "/user/saveContact",
        data: payload,
      });

      if (response?.success === false || response?.status === false) {
        messageApi.open({
          type: "error",
          content: response?.message || "Something went wrong",
        });
        return;
      }

      setIsModalOpen(true);
      setTimeout(() => {
        setIsModalOpen(false);
      }, 3000);
      reset();
      handleClearDate();
      setSelectedCountry("");
    } catch (error) {
      console.error("Contact submit error:", error);
      messageApi.open({
        type: "error",
        content: error?.response?.data?.message || "Something went wrong",
      });
      reset();
    }
  };

  const [selectedCountry, setSelectedCountry] = useState("");

  const handleCountryChange = (event) => {
    const selectedCountryName = event.target.value;
    const selectedCountryData = CountryData.find(
      (country) => country.name === selectedCountryName
    );

    if (selectedCountryData) {
      setSelectedCountry(selectedCountryData.dial_code);
    }
  };

  const disabledDate = (current) => {
    return current && current < dayjs().endOf("day");
  };

  return (
    <>
      <ContactWrap>
        <Container fluid>
          <Spin spinning={loading}>
            <Row>
              <Col className="ms-4 image-col">
                <div className="img-cont">
                  <img
                    style={{ width: "550px", height: "700px" }}
                    src={imagefive}
                    alt="image"
                  />
                </div>
              </Col>

              <Col md={12} lg={6}>
                {contextHolder}
                <Form onSubmit={handleSubmit(onSubmit)}>
                  <Row className="pt-4 mt-4 px-4 mx-4 contact-form">
                    <Col xs={12} lg={6} className="mb-3">
                      <Form.Group
                        className="text-start"
                        controlId="formFirstName"
                      >
                        <Form.Label className="label-custom">
                          First Name
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder=" "
                          {...register("fname", {
                            required: "This field is required",
                          })}
                          name="fname"
                          onKeyDown={(e) => {
                            const allowedChars = /^[a-zA-Z\s]+$/;
                            if (!allowedChars.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          maxLength={15}
                        />
                      </Form.Group>
                      {errors.fname && (
                        <span className="error-msg">
                          {errors.fname.message}
                        </span>
                      )}
                    </Col>
                    <Col xs={12} lg={6} className="mb-3">
                      <Form.Group
                        className="text-start"
                        controlId="formLastName"
                      >
                        <Form.Label className="label-custom">
                          Last Name
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder=" "
                          {...register("lname", {
                            required: "This field is required",
                          })}
                          name="lname"
                          onKeyDown={(e) => {
                            const allowedChars = /^[a-zA-Z\s]+$/;
                            if (!allowedChars.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          maxLength={15}
                        />
                      </Form.Group>
                      {errors.lname && (
                        <span className="error-msg">
                          {errors.lname.message}
                        </span>
                      )}
                    </Col>
                  </Row>

                  <Row className="px-4 mx-4 contact-form">
                    <Col xs={12} lg={6} className="mb-3">
                      <Form.Group controlId="formCountry">
                        <Form.Label className="label-custom">
                          Country
                        </Form.Label>
                        <Form.Select
                          {...register("country", {
                            required: "This field is required",
                          })}
                          name="country"
                          onChange={(e) => {
                            handleCountryChange(e);
                            clearErrors("country");
                          }}
                          autoComplete="off"
                        >
                          <option value="">Select Country</option>
                          {CountryData.map((country, index) => (
                            <option key={index} value={country.name}>
                              {country.name}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                      {errors.country && (
                        <span className="error-msg">
                          This field is required
                        </span>
                      )}
                    </Col>

                    <Col xs={12} lg={6} className="mb-3">
                      <Form.Group controlId="formPhone">
                        <Form.Label className="label-custom">
                          Phone (Optional)
                        </Form.Label>
                        <InputGroup>
                          {selectedCountry && (
                            <InputGroup.Text id="basic-addon1">
                              {" "}
                              {selectedCountry}
                            </InputGroup.Text>
                          )}
                          <Form.Control
                            {...register("phoneNumber")}
                            className="placeholder-style"
                            name="phoneNumber"
                            type="tel"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            onChange={(event) => {
                              sanitizeDigits(event);
                              register("phoneNumber").onChange(event);
                            }}
                            autoComplete="off"
                            maxLength={10}
                          />
                        </InputGroup>
                      </Form.Group>
                      {errors.phoneNumber && (
                        <span className="error-msg">
                          {errors.phoneNumber.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                  <Row className="px-4 mx-4 contact-form">
                    <Col lg={12} className="mb-3">
                      <Form.Group className="text-start" controlId="formEmail">
                        <Form.Label className="label-custom">
                          Work Mail
                        </Form.Label>
                        <Form.Control
                          type="email"
                          placeholder=""
                          name="emailid"
                          {...register("emailid", {
                            required: "This field is required",
                            // pattern: {
                            //   value:
                            //     /^[a-zA-Z0-9.%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                            //   message: "Please enter a valid email",
                            // },
                          })}
                        />
                        <span className="error-msg">
                          {errors.emailid?.message}
                        </span>
                      </Form.Group>
                    </Col>
                    <Col lg={12} className="mb-3">
                      <Form.Group
                        className="text-start"
                        controlId="formCompanyName"
                      >
                        <Form.Label className="label-custom">
                          Company Name
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder=""
                          {...register("companyName", {
                            required: "This field is required",
                          })}
                          name="companyName"
                          maxLength={15}
                        />
                      </Form.Group>
                      {errors.companyName && (
                        <span className="error-msg">
                          This field is required
                        </span>
                      )}
                    </Col>
                  </Row>

                  <Row className="px-4 mx-4 contact-form">
                    <Col xs={12} lg={6} className="mb-3">
                      <Form.Group className="text-start" controlId="formRole">
                        <Form.Label className="label-custom">
                          Your Role
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder=" "
                          {...register("role", {
                            required: "This field is required",
                          })}
                          name="role"
                          maxLength={15}
                        />
                      </Form.Group>
                      {errors.role && (
                        <span className="error-msg">
                          This field is required
                        </span>
                      )}
                    </Col>
                    <Col xs={12} lg={6} className="mb-3">
                      <Form.Group
                        className="text-start"
                        controlId="formIndustry"
                      >
                        <Form.Label className="label-custom">
                          Industry
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder=""
                          {...register("industry", {
                            required: "This field is required",
                          })}
                          name="industry"
                          maxLength={30}
                        />
                      </Form.Group>
                      {errors.industry && (
                        <span className="error-msg">
                          This field is required
                        </span>
                      )}
                    </Col>
                  </Row>

                  <Row className="px-4 mx-4 contact-form">
                    <Col xs={12} lg={6} className="mb-3">
                      <Form.Group
                        className="text-start"
                        controlId="formNumberOfVehicles"
                      >
                        <Form.Label className="label-custom">
                          Number of Vehicles
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder=""
                          inputMode="numeric"
                          pattern="[0-9]*"
                          {...register("numberOfVehicles", {
                            required: "This field is required",
                          })}
                          onChange={(event) => {
                            sanitizeDigits(event);
                            register("numberOfVehicles").onChange(event);
                          }}
                          name="numberOfVehicles"
                          maxLength={15}
                        />
                      </Form.Group>
                      {errors.numberOfVehicles && (
                        <span className="error-msg">
                          This field is required
                        </span>
                      )}
                    </Col>

                    <Col xs={12} lg={6} className="mb-3">
                      <Form.Group
                        className="text-start"
                        controlId="formDateAvailable"
                      >
                        <Form.Label className="label-custom">
                          Date Available
                        </Form.Label>
                        <br />
                        <Controller
                          name="date"
                          control={control}
                          render={({ field }) => (
                            <DatePicker {...field} format="DD/MM/YYYY" />
                          )}
                        />
                      </Form.Group>
                      {errors.date && (
                        <span className="error-msg">
                          {errors.date.message}
                        </span>
                      )}
                    </Col>
                  </Row>

                  <Row className="px-4 mx-4 contact-form">
                    <Col lg={12} className="mb-3">
                      <Form.Group
                        className="text-start"
                        controlId="formDescription"
                      >
                        <Form.Label className="label-custom">
                          Description
                        </Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={4}
                          placeholder=""
                          {...register("description")}
                          name="description"
                        />
                      </Form.Group>
                      {errors.description && (
                        <span className="error-msg">
                          {errors.description.message}
                        </span>
                      )}
                    </Col>
                  </Row>

                  <div className="d-flex justify-content-center align-items-center">
                    <button
                      style={{ background: "green", border: "none" }}
                      className="theme-filldbtn my-4 ms-4"
                    >
                      Submit
                    </button>{" "}
                  </div>
                </Form>
              </Col>
            </Row>
          </Spin>
        </Container>
        <Modal open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
          <ContactWrap>
            <Row>
              <Col className="bgimg" lg={12}>
                <img src={popupimage} />
                <div className="d-flex justify-content-center">
                  <img
                    src={isMobile ? circletick : greentick}
                    alt="tick"
                    className="successtick"
                  />
                </div>
              </Col>
              <Col className="content py-4 my-4 text-center" lg={12}>
                <p className="contact-para">Submitted Successfully!</p>
                <p className="contact-para">Our team will reach out soon</p>
              </Col>
            </Row>
          </ContactWrap>
        </Modal>
      </ContactWrap>
    </>
  );
};